import { animate, animation, keyframes, style } from '@angular/animations';

export const pulse = animation(
  [
    style({
      transform: 'scale({{ fromScale }})',
    }),
    animate(
      '{{ duration }}ms {{ delay }}ms',
      keyframes([
        style({ transform: 'scale({{ fromScale }})', offset: 0 }),
        style({ transform: 'scale({{ toScale }})', offset: 0.7 }),
        style({ transform: 'scale(1)', offset: 1 }),
      ]),
    ),
  ],
  {
    params: {
      duration: '200',
      delay: '0',
      fromScale: '0.7',
      toScale: '1.35',
    },
  },
);
